export const song_list = [
    {
        name: "Barrio",
        img: require("../images/pic-1.png"),
        src: require("../music/barrio.mp3")
    },
    {
        name: "HardBrain",
        img: require("../images/pic-2.png"),
        src: require("../music/hardbrain.mp3")
    },
    {
        name: "Nomad",
        img: require("../images/pic-3.png"),
        src: require("../music/nomad.mp3")
    },
    {
        name: "TastyToo",
        img: require("../images/pic-4.png"),
        src: require("../music/tastytoo.mp3")
    },
    {
        name: "Firebird",
        img: require("../images/pic-5.png"),
        src: require("../music/firebird.mp3")
    },
    {
        name: "Pyrolyse",
        img: require("../images/pic-6.png"),
        src: require("../music/pyrolyse.mp3")
    },
    {
        name: "Awoo",
        img: require("../images/pic-7.png"),
        src: require("../music/awoo.mp3")
    }
];
